import { Icon } from "@chakra-ui/react";
import { SideNavBody } from "../../components/containers/sideNavLayout/SideNavBody";
import { SideNavBar } from "../../components/containers/sideNavLayout/SideNavBar";
import { SideNavLayout } from "../../components/containers/sideNavLayout/SideNavLayout";
import { SideNavGroup } from "../../components/containers/sideNavLayout/SideNavGroup";
import { SideNavItem } from "../../components/containers/sideNavLayout/SideNavItem";
import { Outlet } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import { IoMdAdd } from "react-icons/io";
import { PiSquaresFour } from "react-icons/pi";
import { MdOutlineInsights } from "react-icons/md";
import { useState } from "react";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../../lib/cache";
import { insightsOnlyAdvertisersUsers } from "../../routes/campaignRoutes";
import { BrandChoicesEnum } from "../../graphqlExternal/generated";

export const BuyerHomePage: React.FC = () => {
  const currentUser = useReactiveVar(userDetailsVar);
  const [pageTitle, setPageTitle] = useState("Campaigns");

  return (
    <SideNavLayout pageTitle={pageTitle}>
      <SideNavBar>
        <SideNavGroup
          title={"Campaigns"}
          icon={<Icon as={PiSquaresFour} width={6} height={6} />}
        >
          {(currentUser?.isStaff ||
            insightsOnlyAdvertisersUsers.includes(
              currentUser?.agency.name as BrandChoicesEnum
            )) && (
            <SideNavItem
              title={"Brand Safety Insights"}
              url={"brand-safety-insights"}
              isSubItem={true}
              icon={<Icon as={MdOutlineInsights} width={6} height={6} />}
              setPageTitle={setPageTitle}
            />
          )}
          {(currentUser?.isStaff ||
            !insightsOnlyAdvertisersUsers.includes(
              currentUser?.agency.name as BrandChoicesEnum
            )) && (
            <SideNavItem
              title={"All Campaigns"}
              url={"all-campaigns"}
              isSubItem={true}
              icon={<Icon as={CiViewList} width={6} height={6} />}
              setPageTitle={setPageTitle}
            />
          )}
          {(currentUser?.isStaff ||
            !insightsOnlyAdvertisersUsers.includes(
              currentUser?.agency.name as BrandChoicesEnum
            )) && (
            <SideNavItem
              title={"New Campaign"}
              url={"new"}
              isSubItem={true}
              icon={<Icon as={IoMdAdd} width={6} height={6} />}
              setPageTitle={setPageTitle}
            />
          )}
        </SideNavGroup>
      </SideNavBar>

      <SideNavBody pageTitle={pageTitle}>
        <Outlet />
      </SideNavBody>
    </SideNavLayout>
  );
};
